import script from "./FloatActionWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatActionWidget.vue?vue&type=script&setup=true&lang=ts"

import "./FloatActionWidget.vue?vue&type=style&index=0&id=085d4c08&lang=scss"

const __exports__ = script;

export default __exports__